import { Routes } from 'react-router-dom';
import {
  AuthRoutes,
  ClauseRoutes,
  DataRoutes,
  DealRoutes,
  DocumentRoutes,
  HelpRoutes,
  HomeRoutes,
  MobileWarningRoute,
  NotFound,
  AccountRoute,
  ApiDocsRoute,
  SettingsRoutes,
  TeamRoutes,
  TemplateRoutes,
  TrackerRoutes,
} from './routes';

const WebappRouter = () => {
  return (
    <>
      <Routes>
        {AuthRoutes()}
        {HomeRoutes()}
        {DealRoutes()}
        {TrackerRoutes()}
        {DataRoutes()}
        {DocumentRoutes()}
        {TeamRoutes()}
        {TemplateRoutes()}
        {ClauseRoutes()}
        {SettingsRoutes()}
        {HelpRoutes()}
        {MobileWarningRoute()}
        {AccountRoute()}
        {ApiDocsRoute()}
        {NotFound()}
      </Routes>
    </>
  );
};

export default WebappRouter;
